import type { Address, Client } from '../models/Client';
import type { Organization } from '../models/Organization';

export interface ProjectContact {
  email?: string;
  phone?: string;
  address?: Address;
  clientAccountId?: string;
  clientAccountName?: string;
}

type ProjectLike = Pick<
  Client,
  'email' | 'phone' | 'address' | 'clientId' | 'organizationId'
> | null | undefined;

type ClientAccountLike = Pick<
  Organization,
  'id' | 'name' | 'email' | 'phone' | 'address'
> | null | undefined;

/** Prefer linked client-account contact; fall back to legacy project fields. */
export function resolveProjectContact(
  project: ProjectLike,
  clientAccount: ClientAccountLike
): ProjectContact {
  return {
    email: clientAccount?.email || project?.email || undefined,
    phone: clientAccount?.phone || project?.phone || undefined,
    address: clientAccount?.address || project?.address || undefined,
    clientAccountId:
      clientAccount?.id || project?.clientId || project?.organizationId || undefined,
    clientAccountName: clientAccount?.name,
  };
}

export function findClientAccountForProject(
  project: Pick<Client, 'clientId' | 'organizationId'> | null | undefined,
  clientAccounts: Organization[]
): Organization | undefined {
  const id = project?.clientId || project?.organizationId;
  if (!id) return undefined;
  return clientAccounts.find((account) => account.id === id);
}

export function resolveProjectContactEmail(
  project: ProjectLike,
  clientAccount: ClientAccountLike
): string {
  return resolveProjectContact(project, clientAccount).email || '';
}
